import * as React from 'react';
import { t } from '@moovly/i18n';
import { IconDelete, IconError, IconPlus, IconUnlink } from '@moovly/ui';
import { useNavigate } from 'react-router-dom';
import './UsersTableRow.scss';
import { LicenseData } from '../../../subscriptions/types/licenses';
import { TableUser } from './UsersTable';
import { RemoveMemberProps } from '../../modals/RemoveMemberModal';
import { formatDate } from '../../../../utils/date';
import { TableAction, TableCol, TableRow } from '../../../../components/Table';

interface UsersTableRowProps {
  user: TableUser;
  onRemoveMember: (user: RemoveMemberProps) => void;
  onRevoke: (license: LicenseData) => void;
}
const UsersTableRow: React.FC<UsersTableRowProps> = ({ user, onRemoveMember, onRevoke }) => {
  const nav = useNavigate();
  const isActive = React.useMemo(() => user.license && !user.license.is_expired, [user]);
  const is_expired = React.useMemo(() => user.license?.is_expired, [user]);
  const isInactive = React.useMemo(() => !user.license, [user]);

  const handleDelete = React.useCallback(() => {
    onRemoveMember({ userId: user.uuid, name: user.name });
  }, [user, onRemoveMember]);
  const handleRevoke = React.useCallback(() => {
    onRevoke(user.license!);
  }, [onRevoke, user]);
  const handleAssignSubscription = React.useCallback(() => {
    nav(`/users/${user.uuid}/subscription`);
  }, [nav, user]);
  const handleClickUser = React.useCallback((e: any) => nav(`/users/${user.uuid}`), [nav, user]);
  return (
    <TableRow onClick={handleClickUser} className="UsersTableRow">
      <TableCol>{user.name || '-'}</TableCol>
      <TableCol className="email-col">
        <span className="d-flex align-items-center">
          {is_expired && (
            <span className="me-2 text-danger">
              <IconError height={16} />
            </span>
          )}
          {user.emailAddress}
        </span>
      </TableCol>
      <TableCol>{!!user.lastLoginAt ? formatDate(user.lastLoginAt) : '-'}</TableCol>
      <TableCol>{user.projectCount !== undefined ? user.projectCount : '/'}</TableCol>
      <TableCol>{user.licenseName || '-'}</TableCol>
      <TableCol>{user.licenseExpiresAt || '-'}</TableCol>
      <TableCol>{user.role}</TableCol>
      <TableCol>
        <div className="d-flex">
          {(is_expired || isInactive) && (
            <TableAction icon={IconPlus} onClick={handleAssignSubscription} tooltip={t('tooltips.add')} />
          )}
          {(isActive || is_expired) && (
            <TableAction icon={IconUnlink} onClick={handleRevoke} tooltip={t('tooltips.remove')} />
          )}
          {isInactive && (
            <TableAction icon={IconDelete} iconSize={16} onClick={handleDelete} tooltip={t('tooltips.delete')} />
          )}
        </div>
      </TableCol>
    </TableRow>
  );
};
export default UsersTableRow;
